// Performance monitoring utility for analytics
class PerformanceMonitor {
    constructor() {
        this.metrics = new Map();
        this.startTimes = new Map();
    }

    startTimer(name) {
        this.startTimes.set(name, performance.now());
    }

    endTimer(name) {
        const startTime = this.startTimes.get(name);
        if (startTime) {
            const duration = performance.now() - startTime;
            this.metrics.set(name, duration);
            this.startTimes.delete(name);
            
            // Log to console in development
            if (process.env.NODE_ENV === 'development') {
            
            }
            
            return duration;
        }
        return 0;
    }

    getMetric(name) {
        return this.metrics.get(name);
    }

    getAllMetrics() {
        return Object.fromEntries(this.metrics);
    }

    clearMetrics() {
        this.metrics.clear();
        this.startTimes.clear();
    }

    // Track quotes loading performance
    trackQuotesLoading(orderCount, duration) {
        const avgTimePerOrder = duration / orderCount;

        
        // Store for potential analytics
        this.metrics.set('quotes_loading_total', duration);
        this.metrics.set('quotes_loading_avg_per_order', avgTimePerOrder);
        this.metrics.set('quotes_loading_order_count', orderCount);
    }
}

// Export singleton instance
export const performanceMonitor = new PerformanceMonitor();

// Helper functions
export const withPerformanceTracking = (name, fn) => {
    return async (...args) => {
        performanceMonitor.startTimer(name);
        try {
            const result = await fn(...args);
            performanceMonitor.endTimer(name);
            return result;
        } catch (error) {
            performanceMonitor.endTimer(name);
            throw error;
        }
    };
}; 